import OverlayEnum from '../enums.ts';
import { SET_OVERLAYS_ACTION } from './store';
import { iSspProviderContext } from './interfaces';
import { iOverlayDisc } from '../interfaces.ts';

export function addOverlay(
    store: iSspProviderContext,
    overlay: OverlayEnum | iOverlayDisc
) {
    store.dispatch({
        type: SET_OVERLAYS_ACTION,
        value: [...store.state.overlays, overlay],
    });
}

export function goBack(store: iSspProviderContext) {
    store.dispatch({
        type: SET_OVERLAYS_ACTION,
        value: store.state.overlays.slice(0, -1),
    });
}
